var map = {
	"./Logo.svg": "5fb4",
	"./Non-window.svg": "2118",
	"./airport.svg": "354b",
	"./airportpickup.svg": "8a8d",
	"./alarmclock.svg": "c39d",
	"./aliPay.svg": "841d",
	"./baggagedeposit.svg": "9cba",
	"./bathroom.svg": "6847",
	"./car.svg": "175b",
	"./card-american.svg": "d486",
	"./card-dinners.svg": "b168",
	"./card-discover.svg": "262d",
	"./card-jcb.svg": "ff3b",
	"./card-master.svg": "0897",
	"./card-unionpay.svg": "7080",
	"./card-visa.svg": "654c",
	"./carrentalfacilitie.svg": "1f6d",
	"./check_in.svg": "be4a",
	"./check_out.svg": "5f1a",
	"./circle-check.svg": "e1e2",
	"./city.svg": "38db",
	"./creditcard.svg": "8490",
	"./currency.svg": "70dc",
	"./custom.svg": "2783",
	"./decoratedAt.svg": "ede0",
	"./district.svg": "26a4",
	"./down-circle.svg": "4adb",
	"./drink.svg": "e0bc",
	"./emission.svg": "47b1",
	"./exclamation.svg": "1931",
	"./exclamationNew.svg": "81fa",
	"./eye.svg": "4545",
	"./eye2.svg": "1e93",
	"./general.svg": "5cd5",
	"./guest.svg": "8ae6",
	"./gymnasium.svg": "a8f9",
	"./hotel.svg": "264f",
	"./hotel_icon_diamond.svg": "8c96",
	"./ic_area.svg": "7554",
	"./ic_area1.svg": "9696",
	"./ic_bed.svg": "3b5e",
	"./ic_domain.svg": "c30b",
	"./ic_domain1.svg": "52fd",
	"./ic_help_outline.svg": "ff7c",
	"./ic_home.svg": "dc42",
	"./ic_location.svg": "beeb",
	"./ic_location_big.svg": "cfb6",
	"./ic_location_result.svg": "f589",
	"./ic_map.svg": "949b",
	"./ic_menu.svg": "b6a4",
	"./ic_result_CorpPayHotel.svg": "c46b",
	"./ic_result_cwtHotel.svg": "7a19",
	"./ic_result_hotelMarke.svg": "92f1",
	"./ic_result_notRecommended.svg": "b38a",
	"./lang-en.svg": "b8b9",
	"./lang-zh.svg": "8645",
	"./location.svg": "3b0d",
	"./next.svg": "cc79",
	"./openedAt.svg": "a52d",
	"./park.svg": "cad9",
	"./phone.svg": "6f95",
	"./pool.svg": "b22c",
	"./question.svg": "cb54",
	"./reception.svg": "79b9",
	"./restaurants.svg": "378f",
	"./right.svg": "cf81",
	"./search.svg": "a8c7",
	"./star.svg": "d26d",
	"./to.svg": "2e09",
	"./up-circle-fill.svg": "6dd9",
	"./weChatPay.svg": "f263",
	"./wifi.svg": "d4be",
	"./wifi_2.svg": "7622",
	"./wifi_3.svg": "3a88",
	"./window.svg": "702f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47be";